import { Link } from "react-router-dom";
import { Bell, ScanLine } from "lucide-react";
import SearchSuggest from "@/components/SearchSuggest";
import { useAuth } from "@/context/auth";
import { useUnread } from "@/hooks/queries";
import { Avatar } from "@/components/ContactRow";
import { AvatarCrown, PremiumBadge, useIsPremium } from "@/components/PremiumBadge";

export default function DesktopTopBar() {
  const { user } = useAuth();
  const premium = useIsPremium();
  const unread = useUnread().data?.count ?? 0;
  return (
    <header className="hidden lg:flex sticky top-0 z-30 h-[72px] items-center gap-4 px-10 bg-white/85 backdrop-blur-xl border-b border-[#E2E8F0]" data-testid="desktop-topbar">
      <SearchSuggest />
      <Link to="/scan" className="t-btn t-btn-primary h-[46px] px-5 text-[15px]" data-testid="topbar-scan"><ScanLine className="w-5 h-5" />Scan a Card</Link>
      <Link to="/notifications" className="relative t-iconbtn w-[46px] h-[46px] rounded-full" data-testid="topbar-notifications">
        <Bell className="w-5 h-5" />
        {unread > 0 && <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#DC2626] text-white text-[11px] font-bold flex items-center justify-center">{unread}</span>}
      </Link>
      <Link to="/profile" className="flex items-center gap-3 pl-2 pr-3 h-[46px] rounded-full hover:bg-[#F1F5F9] transition-colors" data-testid="topbar-profile">
        <AvatarCrown show={premium}><Avatar name={user?.name} size={36} /></AvatarCrown>
        <span className="text-left leading-tight"><span className="flex items-center gap-1.5 text-[14px] font-bold">{user?.name}{premium && <PremiumBadge size="sm" testid="topbar-premium-badge" />}</span><span className="block text-[12px] text-[#64748B]">{user?.companyName || user?.email}</span></span>
      </Link>
    </header>
  );
}
